
import { Vue, Options } from "vue-class-component";
import HeaderMenu from "@/components/header/HeaderMenu.vue";
import HeaderTherapist from "@/components/header/HeaderTherapist.vue";
import NavigationBar from "@/components/header/NavigationBar.vue";
import NavigationMobile from "@/components/header/NavigationMobile.vue";
import MainProgress from "./MainProgress.vue";
import { useStore } from "vuex";
import ProgressModal from "@/components/ProgressModal.vue"
import StorageService from "@/services/StorageService";
import ApiService from "../services/ApiService";
import { wrapper } from "@/utils/wrapper";
import { calculateTreamentProgress } from "@/utils/progress";

@Options({
  components: {
    HeaderMenu,
    HeaderTherapist,
    NavigationBar,
    NavigationMobile,
    MainProgress,
    ProgressModal
  },
  props: {
    menus: Boolean
  }
} as any)
export default class Header extends Vue {
  private storageService = new StorageService();
  private apiService = new ApiService();
  user: any = null;
  expanded = false
  mainProgressMainColor = '#a9ad47'
  mainProgressWidth = 40
  mainProgressBorderThick = 30
  mainProgressFontSize = '0.5em'
  showProgressModal = false
  globalStore = useStore();

  async created() {
    this.user = this.storageService.getUser();
    await this.getTreatment(this.user.patientsId);
  }

  async getTreatment(patientsId: number) {
    const treatment = await wrapper(
      this.apiService.getTreatment(patientsId)
    );
    if (treatment.error) {
      console.error("get modules error ", treatment.error);
      throw treatment.error;
    }

    this.globalStore.commit('setMainProgress', await calculateTreamentProgress(patientsId, treatment.data.id));

    if (treatment.data) {
      return treatment.data;
    }
  }

  expandHeadermenu () {
    this.expanded = true
  }
  closeMenu () {
    this.expanded = false
  }

  onChildClick () {
    this.showProgressModal = false
  }

  openProgressModal () {
    this.showProgressModal = true
  }

  get currentPercentage() {
    return this.globalStore.getters.getTreatmentProgress
  }
}
